import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            redirect: `/login`
        },

        {
            path: '/None',
            component: () => import('../components/page/None.vue'),
            meta: { title: '大屏展示' }
        },
        {
            path: '/',
            component: () => import(`../components/common/Home.vue`),
            meta: { title: '自述文件' },
            children: [
                {
                    path: '/ACompany',
                    component: () => import('../components/page/ACompany.vue'),
                    meta: { title: '企业管理', permission: true }
                },
                {
                    path: '/AProject',
                    component: () => import('../components/page/AProject.vue'),
                    meta: { title: '项目管理', permission: true }
                },
                {
                    path: '/AUser',
                    component: () => import('../components/page/AUser.vue'),
                    meta: { title: '用户管理', permission: true }
                },
                {
                    path: '/AProjectDevice',
                    component: () => import('../components/page/AProjectDevice.vue'),
                    meta: { title: '设备列表', permission: true }
                },
                {
                    path: '/ADeviceDetail',
                    component: () => import('../components/page/ADeviceDetail.vue'),
                    meta: { title: '设备详情' }
                },
                {
                    path: '/ADashboard',
                    component: () => import('../components/page/ADashboard.vue'),
                    meta: { title: '首页' }
                },
                {
                    path: '/Asystem',
                    component: () => import('../components/page/Asystem.vue'),
                    meta: { title: '系统设置' }
                },
                {
                    path: '/ADevice',
                    component: () => import('../components/page/ADevice.vue'),
                    meta: { title: '设备管理' }
                },
                {
                    path: '/ADeviceDetail1',
                    component: () => import('../components/page/ADeviceDetail1.vue'),
                    meta: { title: '设备详情' }
                },
                {
                    path: '/ADeviceDetail2',
                    component: () => import('../components/page/ADeviceDetail2.vue'),
                    meta: { title: '设备详情' }
                },
                {
                    path: '/ADeviceDetail3',
                    component: () => import('../components/page/ADeviceDetail3.vue'),
                    meta: { title: '设备详情' }
                }, {
                    path: '/ADeviceDetail4',
                    component: () => import('../components/page/ADeviceDetail4.vue'),
                    meta: { title: '设备详情' }
                },
                {
                    path: '/ADeviceDetail5',
                    component: () => import('../components/page/ADeviceDetail5.vue'),
                    meta: { title: '设备详情' }
                },
                {
                    path: '/ADeviceDetail6',
                    component: () => import('../components/page/ADeviceDetail6.vue'),
                    meta: { title: '设备详情' }
                }, {
                    path: '/ADeviceDetail7',
                    component: () => import('../components/page/ADeviceDetail7.vue'),
                    meta: { title: '设备详情' }
                }, {
                    path: '/ADeviceDetail8',
                    component: () => import('../components/page/ADeviceDetail8.vue'),
                    meta: { title: '设备详情' }
                }, {
                    path: '/ADeviceDetail9',
                    component: () => import('../components/page/ADeviceDetail9.vue'),
                    meta: { title: '设备详情' }
                },





                // {
                //     path: '/AProjectDetail',
                //     component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/AProjectDetail.vue'),
                //     meta: { title: '项目详情' }
                // },





                // ------------------

                {
                    path: '/device',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/Device.vue'),
                    meta: { title: '设备管理' },
                    children: [
                        {
                            path: '/device/deviceList',
                            component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/Device.vue'),
                            meta: { title: '设备列表' },
                        }
                    ]
                },
                {
                    path: '/dashboard',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/Dashboard.vue'),
                    meta: { title: '系统首页' }
                },
                {
                    path: '/project',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/project.vue'),
                    meta: { title: '项目管理' }
                },
                {
                    path: '/Config',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/Config.vue'),
                    meta: { title: '个人设置' }
                },
                {
                    path: '/SystemConfig',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/SystemConfig.vue'),
                    meta: { title: '系统设置' }
                },

                // ------

                {
                    path: '/AlarmRecord',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/AlarmRecord.vue'),
                    meta: { title: '报警记录' }
                }, {
                    path: '/FaultRecord',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/FaultRecord.vue'),
                    meta: { title: '故障记录' }
                },

                {
                    path: '/User',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/User.vue'),
                    meta: { title: '管理员' }
                },
                {
                    path: '/AMaintainUser',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/AMaintainUser.vue'),
                    meta: { title: '维保人员' }
                },
                {
                    path: '/ATask',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/ATask.vue'),
                    meta: { title: '工单中心' }
                },


                {
                    path: '/Role',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/Role.vue'),
                    meta: { title: '角色管理' }
                },
                {
                    path: '/Notif',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/Notif.vue'),
                    meta: { title: '消息中心' }
                },
                {
                    path: '/StatisticsStatus',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/StatisticsStatus.vue'),
                    meta: { title: '设备状态分析' }
                },
                {
                    path: '/StatisticsAlarm',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/StatisticsAlarm.vue'),
                    meta: { title: '设备报警分析' }
                },
                {
                    path: '/StatisticsFault',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/StatisticsFault.vue'),
                    meta: { title: '设备故障分析' }
                },
                // {
                //     path: '/Prformance',
                //     component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/Prformance.vue'),
                //     meta: { title: '绩效考核' }
                // }, 
                {
                    path: '/PrformanceAdmin',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/PrformanceAdmin.vue'),
                    meta: { title: '管理员绩效考核' }
                },
                {
                    path: '/PrformanceUser',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/PrformanceUser.vue'),
                    meta: { title: '维保人员绩效考核' }
                },

                {
                    path: '/DeviceDetail',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/DeviceDetail.vue'),
                    meta: { title: '设备详情' }
                },
                {
                    path: '/HistroyAlarm',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/HistroyAlarm.vue'),
                    meta: { title: '历史报警' }
                },
                {
                    path: '/HistroyFault',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/HistroyFault.vue'),
                    meta: { title: '历史维护' }
                },
                {
                    path: '/VedioMax',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/VedioMax.vue'),
                    meta: { title: '实时摄像' }
                },
                {
                    path: '/SiteDetail',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/SiteDetail.vue'),
                    meta: { title: '站点详情' }
                },



                {
                    path: '/icon',
                    component: () => import(/* webpackChunkName: "icon" */ '../components/page/Icon.vue'),
                    meta: { title: '自定义图标' }
                },
                {
                    path: '/table',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/BaseTable.vue'),
                    meta: { title: '基础表格' }
                },
                {
                    path: '/tabs',
                    component: () => import(/* webpackChunkName: "tabs" */ '../components/page/Tabs.vue'),
                    meta: { title: 'tab选项卡' }
                },
                {
                    path: '/form',
                    component: () => import(/* webpackChunkName: "form" */ '../components/page/BaseForm.vue'),
                    meta: { title: '基本表单' }
                },
                {
                    // 富文本编辑器组件
                    path: '/editor',
                    component: () => import(/* webpackChunkName: "editor" */ '../components/page/VueEditor.vue'),
                    meta: { title: '富文本编辑器' }
                },
                {
                    // markdown组件
                    path: '/markdown',
                    component: () => import(/* webpackChunkName: "markdown" */ '../components/page/Markdown.vue'),
                    meta: { title: 'markdown编辑器' }
                },
                {
                    // 图片上传组件
                    path: '/upload',
                    component: () => import(/* webpackChunkName: "upload" */ '../components/page/Upload.vue'),
                    meta: { title: '文件上传' }
                },
                {
                    // vue-schart组件
                    path: '/charts',
                    component: () => import(/* webpackChunkName: "chart" */ '../components/page/BaseCharts.vue'),
                    meta: { title: 'schart图表' }
                },
                {
                    // 拖拽列表组件
                    path: '/drag',
                    component: () => import(/* webpackChunkName: "drag" */ '../components/page/DragList.vue'),
                    meta: { title: '拖拽列表' }
                },
                {
                    // 拖拽Dialog组件
                    path: '/dialog',
                    component: () => import(/* webpackChunkName: "dragdialog" */ '../components/page/DragDialog.vue'),
                    meta: { title: '拖拽弹框' }
                },
                {
                    // 国际化组件
                    path: '/i18n',
                    component: () => import(/* webpackChunkName: "i18n" */ '../components/page/I18n.vue'),
                    meta: { title: '国际化' }
                },
                {
                    // 权限页面
                    path: '/permission',
                    component: () => import(/* webpackChunkName: "permission" */ '../components/page/Permission.vue'),
                    meta: { title: '权限测试', permission: true }
                },
                {
                    path: '/404',
                    component: () => import(/* webpackChunkName: "404" */ '../components/page/404.vue'),
                    meta: { title: '404' }
                },
                {
                    path: '/403',
                    component: () => import(/* webpackChunkName: "403" */ '../components/page/403.vue'),
                    meta: { title: '403' }
                },
                {
                    path: '/donate',
                    component: () => import(/* webpackChunkName: "donate" */ '../components/page/Donate.vue'),
                    meta: { title: '支持作者' }
                }
            ]
        },
        {
            path: '/login',
            component: () => import(/* webpackChunkName: "login" */ '../components/page/Login.vue'),
            meta: { title: '登录' }
        },
        {
            path: '/maxweb',
            component: () => import(/* webpackChunkName: "login" */ '../components/page/maxweb.vue'),
            meta: { title: '监测平台' }
        },
        {
            path: '/ANewMaxWeb',
            name: 'ANewMaxWeb',
            component: () => import(/* webpackChunkName: "login" */ '../components/page/ANewMaxWeb.vue'),
            meta: { title: '新监测平台' }
        },
        {
            path: '/maxwebCopy',
            component: () => import(/* webpackChunkName: "login" */ '../components/page/maxwebCopy.vue'),
            meta: { title: '监测平台复制' }
        },

        {
            path: '*',
            redirect: '/404'
        }
    ]
});
